import React, { useState } from 'react';

import LogoLoader from 'components/Loader/LogoLoader';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import TimesheetForm from 'containers/TimesheetMileage/shared/TimesheetForm';
import { useFetchPaginatedCustomFields } from 'hooks/customField/useFetchPaginatedCustomFields';
import { hasCustomFieldAccess, transformCustomFieldsToFormData } from 'utils/customFieldsUtils';

import { initialTimesheetFormData } from '../shared/TimesheetForm/schema';

const AddTimesheet: React.FC<unknown> = () => {
  const [formData, setFormData] = useState<typeof initialTimesheetFormData>(initialTimesheetFormData);

  const access = hasCustomFieldAccess();

  const { status, fetchStatus, data } = useFetchPaginatedCustomFields(
    {
      page: 1,
      page_size: 500,
      module: 'timesheets',
      active: '1',
    },
    {
      onSuccess: (data: any) => {
        if (Array.isArray(data?.payload) && data?.payload.length) {
          const customFields = transformCustomFieldsToFormData(data?.payload);

          const formData: typeof initialTimesheetFormData = {
            ...initialTimesheetFormData,
            ...customFields,
          };

          setFormData(formData);
        }
      },
    }
  );

  if (fetchStatus === 'fetching') return <LogoLoader />;
  if (status === 'error') return <APIErrorMascot />;

  return <TimesheetForm formData={formData} customFieldsData={access ? data?.payload || [] : null} />;
};

export default AddTimesheet;
